import { AdminTypeList } from "@kg-pos/common";
import { AdminDataFragment, AdminResponse } from "__generated__/graphql";

export const getAdminRecord = (
  admin: AdminDataFragment
): Omit<AdminResponse, "type"> & { type: string } => ({
  ...admin,
  type: admin.type ? AdminTypeList[admin.type] : "",
});
